// @dynamic
export class VerificationCodeCore {
  /// <summary>
  /// 计算校验码
  /// </summary>
  /// <param name="codes"></param>
  /// <returns></returns>
  public static GetVerificationCode(codes: string) {
    var result = '';
    if (codes && codes.length == 17) {
      let codesArr = codes.trim().split('');
      if (VerificationCodeCore.IsMatch(codesArr)) {
        const sum = codesArr.reduce((pre, code, index) => {
          var mapCode = VerificationCodeCore.CodeMap1.get(code);
          var calCode = VerificationCodeCore.Calculate(mapCode, index + 1);

          return pre + calCode;
        }, 0);
        var mod = sum % 11;
        result = VerificationCodeCore.CodeMap2.get(mod);
      } else {
        // throw new Warning("参数格式错误");
      }
    } else {
      // throw new Warning("参数格式错误");
    }
    return result;
  }

  /// <summary>
  /// 计算
  /// </summary>
  /// <param name="code"></param>
  /// <param name="i"></param>
  /// <returns></returns>
  private static Calculate(code: number, i: number): number {
    return (code + 1) * i;
  }

  /// <summary>
  /// 验证内容合规
  /// [后期正则替换]
  /// </summary>
  /// <param name="codeArr"></param>
  /// <returns></returns>
  private static IsMatch(codeArr: Array<string>) {
    // foreach (var item in codeArr)
    // {
    //     if (!CodeMap1.Keys.Contains(item))
    //     {
    //         return false;
    //     }
    // }
    return codeArr.every(function (i) {
      return VerificationCodeCore.CodeMap1.get(i) !== undefined;
    });
  }

  /// <summary>
  /// 字典表1
  /// </summary>
  private static CodeMap1 = new Map([
    ['0', 0],
    ['1', 1],
    ['2', 2],
    ['3', 3],
    ['4', 4],
    ['5', 5],
    ['6', 6],
    ['7', 7],
    ['8', 8],
    ['9', 9],

    ['A', 10],
    ['B', 11],
    ['C', 12],
    ['D', 13],
    ['E', 14],
    ['F', 15],
    ['G', 16],
    ['H', 17],
    ['J', 18],
    ['K', 19],
    ['L', 20],
    ['M', 21],
    ['N', 22],
    ['P', 23],
    ['Q', 24],
    ['R', 25],
    ['S', 26],
    ['T', 27],
    ['U', 28],
    ['V', 29],
    ['W', 30],
    ['X', 31],
    ['Y', 32],

    //{"a", 10},
    //{"b", 11},
    //{"c", 12},
    //{"d", 13},
    //{"e", 14},
    //{"f", 15},
    //{"g", 16},
    //{"h", 17},
    //{"j", 18},
    //{"k", 19},
    //{"l", 20},
    //{"m", 21},
    //{"n", 22},
    //{"p", 23},
    //{"q", 24},
    //{"r", 25},
    //{"s", 26},
    //{"t", 27},
    //{"u", 28},
    //{"v", 29},
    //{"w", 30},
    //{"x", 31},
    //{"y", 32},
  ]);

  /// <summary>
  /// 字典表2
  /// </summary>
  private static CodeMap2 = new Map([
    [0, '1'],
    [1, '0'],
    [2, 'X'],
    [3, '9'],
    [4, '8'],
    [5, '7'],
    [6, '6'],
    [7, '5'],
    [8, '4'],
    [9, '3'],
    [10, '2'],
  ]);
}
